import I18n from 'i18n'
import { takeLatest, call, put } from 'redux-saga/effects'

import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import externalCourseParticipantsList, {
  GetListResponse,
} from 'api/administration/externalCourseParticipants/GetList'
import destroyMany from 'api/administration/externalCourseParticipants/DestroyMany'
import {
  DESTROY_EXTERNAL_COURSE_PARTICIPANTS,
  Actions,
  DestroyExternalCourseParticipantsPayload,
} from '../../actions/externalCourseParticipant.action'

function destroyExternalCourseParticipants(ids: (string | number)[]) {
  return destroyMany(ids)
}

const pattern = DESTROY_EXTERNAL_COURSE_PARTICIPANTS

export type DestroyExternalCourseParticipantsAction = ActionWithPayload<
  typeof pattern,
  DestroyExternalCourseParticipantsPayload
>

function* destroyExternalCourseParticipantsSaga(
  action: DestroyExternalCourseParticipantsAction
) {
  try {
    const { ids, externalCourseId, params, callback } = action.payload
    yield call(destroyExternalCourseParticipants, ids)
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess_plural'))
    if (externalCourseId) {
      const resList: GetListResponse = yield call(
        externalCourseParticipantsList,
        externalCourseId,
        params
      )
      callback && callback(resList)
      const { data, total, perPage: resPerPage } = resList
      yield put(
        Actions.setAdministrationListSuccess(
          data,
          total,
          resPerPage,
          params?.sort
        )
      )
    }
  } catch (error) {
    yield put(Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.deleteError_plural'))
    console.error(error)
  }
}

export function* externalDestroyExternalCourseParticipantsSaga() {
  yield takeLatest(pattern, destroyExternalCourseParticipantsSaga)
}
